<template>
  <header
    class="header-container flex items-center shadow-header-bottom relative z-10"
  >
    <div class="logo" @click="router.push('/home')">
      <img
        class="w-[93px] h-[34px] object-cover"
        src="../assets/img/logo.png"
        alt="logo"
      />
    </div>
    <div id="tabs" class="nav-tabs relative flex-1" v-show="!plainLogo">
      <n-tabs
        type="line"
        trigger="hover"
        :value="activeTab"
        @update:value="update"
        pane-style="padding: 0"
        :tabs-padding="24"
        style="--n-tab-gap: 3.75vw; --n-tab-font-size: 16px"
      >
        <n-tab-pane name="home">
          <template #tab>
            <NuxtLink to="/home" class="my-tab">首页</NuxtLink>
          </template>
        </n-tab-pane>
        <!-- <n-tab-pane name="product">
          <template #tab>
            <div class="my-tab">产品服务</div>
          </template>
        </n-tab-pane> -->
        <n-tab-pane name="core">
          <template #tab>
            <div class="my-tab">行业解决方案</div>
          </template>
        </n-tab-pane>
        <n-tab-pane name="about">
          <template #tab>
            <div @click="router.push('/about')" class="my-tab">关于司普</div>
          </template>
        </n-tab-pane>
        <n-tab-pane name="news">
          <template #tab>
            <div @click="router.push('/demo')" class="my-tab">预约演示</div>
          </template>
        </n-tab-pane>
      </n-tabs>
      <!-- 产品服务下拉菜单 -->
      <ul
        class="core-product shadow-common fixed left-[140px] right-[140px] top-16"
        v-show="activeTab === 'product'"
      >
        <n-grid :cols="2">
          <n-grid-item v-for="product in coreProducts" :key="product.title">
            <li class="core-product-item h-full" @click="toProduct(product.id)">
              <h4 class="text-base mb-2">{{ product.title }}</h4>
              <small class="core-product-desc text-xs">
                {{ product.brief }}
              </small>
            </li>
          </n-grid-item>
        </n-grid>
      </ul>

      <!-- 行业解决方案下拉菜单 -->
      <ul
        class="industry-solutions shadow-common fixed left-[140px] right-[140px] top-16"
        v-show="activeTab === 'core'"
      >
        <n-grid :cols="2">
          <n-grid-item
            v-for="solution in industrySolutions"
            :key="solution.name"
          >
            <li
              class="industry-solution-item h-full"
              @click="toIndustrySolution(solution.id)"
            >
              <h4 class="text-base mb-2">{{ solution.name }}</h4>
              <small class="industry-solution-desc text-xs">
                {{ solution.description }}
              </small>
            </li>
          </n-grid-item>
        </n-grid>
      </ul>
    </div>
    <!-- <div v-show="!plainLogo" class="mr-[30px] min-w-32">
      <template v-if="true">
        <n-button
          quaternary
          size="tiny"
          class="btn"
          @click="router.push('/login')"
          >登录</n-button
        >
        <n-button type="primary" size="tiny" class="btn register"
          >注册</n-button
        >
      </template>
      <div v-else>
        <n-popover trigger="click">
          <template #trigger>
            <div class="flex items-center">
              <svg-icon
                name="avatar"
                style="width: 30px; height: 30px"
              ></svg-icon>
              <span style="margin-left: 6px; margin-right: 60px" class="text-xs"
                >用户名</span
              >
            </div>
          </template>
          <div class="edit-user-info text-xs">
            <div
              v-for="info in infos"
              :key="info.label"
              class="flex-between-center"
            >
              <span style="color: var(--text-desc); width: 36px">{{
                info.label
              }}</span>
              <div
                contenteditable
                :data-ph="info.placeholder"
                class="inp flex-1"
              >
                {{ info.value }}
              </div>
              <span style="color: var(--primary)" class="pointer">{{
                info.isEdit ? '保存' : info.editLable
              }}</span>
            </div>
          </div>
        </n-popover>
      </div>
    </div> -->
  </header>
</template>

<script setup lang="ts">
defineProps({
  plainLogo: {
    default: false,
    type: Boolean
  }
})

const activeTab = ref('')
const update = (val: string) => {
  activeTab.value = val
}
useEventListener(
  'mouseleave',
  (e: MouseEvent) => {
    activeTab.value = ''
  },
  '#tabs'
)

const { coreProducts } = useConfig()
const router = useRouter()

// 行业解决方案数据 - 根据图片中的4个模块
const industrySolutions = ref([
  {
    name: '金融保险行业',
    description:
      '司普智能核保行业解决方案、司普智能理赔解决方案、重塑核保理赔,解决行业痛点',
    id: 'finance'
  },
  {
    name: '医药行业',
    description: '医药企业信息库建设、智能生产偏差写作',
    id: 'pharmaceutical'
  },
  {
    name: '教育行业',
    description: '司普智能专家写作系统、司普智能教学助手、教育行业知识图谱',
    id: 'education'
  },
  {
    name: '电力行业',
    description: '行业痛点,解决方案核心价值',
    id: 'pharmaceutical-advanced'
  }
])

function toProduct(id: number) {
  router.push(`/product/${encodeURIComponent(id)}`)
}

function toIndustrySolution(id: string) {
  // 根据行业ID跳转到education.vue页面，并传递对应的id参数
  switch (id) {
    case 'finance':
      router.push('/home/industry-solutions/education?id=1')
      break
    case 'pharmaceutical':
      router.push('/home/industry-solutions/education?id=2')
      break
    case 'education':
      router.push('/home/industry-solutions/education?id=3')
      break
    case 'pharmaceutical-advanced':
      router.push('/home/industry-solutions/education?id=4')
      break
    default:
      router.push('/industry-solutions')
  }
}

const infos = ref([
  {
    label: '账号名',
    value: '用户名',
    isEdit: false,
    editLable: '修改'
  },
  {
    label: '手机号',
    value: '10086100003',
    isEdit: false,
    editLable: '修改'
  },
  {
    label: '邮 箱',
    value: '',
    isEdit: false,
    editLable: '认证',
    placeholder: '未绑定'
  },
  {
    label: '公 司',
    value: '',
    isEdit: false,
    editLable: '设置',
    placeholder: '未设置'
  }
])
</script>

<style lang="scss" scoped>
.header-container {
  height: 64px;
  background: #e1ebfc;
  .logo {
    margin-left: 140px;
    vertical-align: middle;
    .icon-logo {
      width: 100px;
      height: 33px;
    }
  }
  .nav-tabs {
    margin-left: 8.75%;
  }
  .btn {
    width: 60px;
  }
  .register {
    margin-left: 8px;
  }
  .core-product {
    background-color: #fff;
    line-height: 2;
    margin-top: 0px;
  }
  .core-product-item {
    padding: 26px 40px;
    cursor: pointer;
    &:hover {
      background-color: #f4f7ff;
      color: var(--primary);
    }
    .core-product-desc {
      color: var(--text-desc);
    }
    &:hover .core-product-desc {
      color: var(--primary);
    }
  }

  .industry-solutions {
    background-color: #fff;
    line-height: 2;
    margin-top: 0px;
  }

  .industry-solution-item {
    padding: 26px 40px;
    cursor: pointer;
    &:hover {
      background-color: #f4f7ff;
      color: var(--primary);
    }
    .industry-solution-desc {
      color: var(--text-desc);
    }
    &:hover .industry-solution-desc {
      color: var(--primary);
    }
  }
}
.my-tab {
  padding: 20px 13px;
}
.edit-user-info {
  width: 222px;
  border-radius: 2px;
  background: #ffffff;
  line-height: 25px;
  .inp {
    margin: 0 16px;
    outline: none;
  }
  .inp:empty::after {
    content: attr(data-ph);
    color: var(--text-desc);
  }
}

:deep(.n-tabs-tab) {
  padding: 0px;
}
:deep(.n-tabs-tab--active) {
  background: #fff;
}
:deep(.n-tabs-nav-scroll-content) {
  border-bottom-color: transparent !important;
}
// :deep(.n-tabs-tab--active) {
//   background-color: #fff;
// }
</style>
